// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentConfiguration } from './EnvironmentConfiguration';

export const environment: EnvironmentConfiguration = {
  // Env
  production: false,
  env: 'dev',

  // Url
  urlOpenBanking: '/api/open-banking',

  // Keys
  testBankConnector: '338178e6-3d01-564f-9a7b-52ca442459bf',
  oneyCustomBankConnector: 'UID-CUSTOM-BANK',
  appInsights: {
    connectionString:
      'InstrumentationKey=753b8da5-f598-4889-af38-7d16159adedf;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=278a8487-d615-45cb-b920-83ec517041ed',
  },

  // Feature flag
  isTrackingEnabled: true,

  // Notification
  notificationMethod: 'polling',
  webauthNotification: {
    timeoutInSeconds: 10 * 60,
    intervalInSeconds: 10,
  },
  caseStateNotification: {
    timeoutInSeconds: 3 * 60,
    intervalInSeconds: 5,
  },
  bankAccountAnalysisCompletion: {
    timeoutInSeconds: 3 * 60,
    intervalInSeconds: 5,
  },

  // Tagging
  taggingContainers: [
    {
      id: 'tc-container-abtasty',
      uri: 'https://cdn.tagcommander.com/2027/uat/tc_Oney_8.js',
      node: 'head',
    },
    {
      id: 'tc-container-analytics',
      uri: 'https://cdn.tagcommander.com/2027/uat/tc_Oney_5.js',
      node: 'body',
    },
    {
      id: 'tc-container-media',
      uri: 'https://cdn.tagcommander.com/2027/uat/tc_Oney_6.js',
      node: 'body',
    },
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
